/* FAQ: animate the <details> answer height (native behaviour kept; no animation under reduced motion). */

const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function duration() {
  const raw = getComputedStyle(document.documentElement).getPropertyValue('--mk-dur-base').trim();
  if (raw.endsWith('ms')) return parseFloat(raw) || 0;
  if (raw.endsWith('s')) return (parseFloat(raw) || 0) * 1000;
  return 200;
}

document.querySelectorAll('details.mk-faq').forEach((details) => {
  const summary = details.querySelector('summary');
  const answer = details.querySelector('.mk-faq__answer');
  if (!summary || !answer || reduce || typeof answer.animate !== 'function') return;
  let anim = null;

  summary.addEventListener('click', (e) => {
    e.preventDefault();
    if (anim) anim.cancel();
    const ms = duration();
    if (!ms) {
      details.open = !details.open;
      return;
    }
    if (details.open) {
      const h = answer.offsetHeight;
      anim = answer.animate([{ height: `${h}px`, opacity: 1 }, { height: '0px', opacity: 0 }], { duration: ms, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' });
      anim.onfinish = () => {
        details.open = false;
        anim = null;
      };
    } else {
      details.open = true;
      const h = answer.scrollHeight;
      anim = answer.animate([{ height: '0px', opacity: 0 }, { height: `${h}px`, opacity: 1 }], { duration: ms, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' });
      anim.onfinish = () => {
        anim = null;
      };
    }
  });
});
